import { render, staticRenderFns } from "./MusicExplorer.vue?vue&type=template&id=acc9ddbc&scoped=true"
import script from "./MusicExplorer.vue?vue&type=script&lang=js"
export * from "./MusicExplorer.vue?vue&type=script&lang=js"
import style0 from "./MusicExplorer.vue?vue&type=style&index=0&id=acc9ddbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc9ddbc",
  null
  
)

export default component.exports